import { ScrollAnimationWithEase } from '@studiometa/ui';

/**
 * Animation de révélation du footer.
 *
 * Elle n'a de sens que lorsque le footer est en `position: fixed` et se dévoile
 * au scroll. Quand il est trop haut pour le viewport, le composant `Footer` le
 * repasse dans le flux et pose la classe `is-footer-static` : l'animation est
 * alors court-circuitée.
 */
export default class FooterScrollAnimation extends ScrollAnimationWithEase {
  /**
   * Component Configuration
   */
  static config = {
    ...ScrollAnimationWithEase.config,
    name: 'FooterScrollAnimation',
  };

  /**
   * Whether the animation should be skipped.
   * @returns {boolean}
   */
  get isDisabled() {
    return document.documentElement.classList.contains('is-footer-static');
  }

  /**
   * resized hook
   */
  resized() {
    // Remet le footer à sa position finale si l'animation vient d'être désactivée.
    if (this.isDisabled) {
      this.render(1);
    }
  }

  /**
   * scrolledInView hook
   * @param {object} props
   */
  scrolledInView(props) {
    if (this.isDisabled) {
      return;
    }

    super.scrolledInView(props);
  }
}
